var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("fieldset", { staticClass: "program-delivery" }, [
    _c("legend", [_vm._v(_vm._s(_vm.t("app-program-delivery")))]),
    _vm._v(" "),
    _c("div", { staticClass: "ui-form-row" }, [
      _c("fieldset", { staticClass: "ui-option-fields-fieldset" }, [
        _c("legend", [_vm._v(_vm._s(_vm.t("app-program-is-delivered-how")))]),
        _vm._v(" "),
        _c("div", { staticClass: "field-description" }, [
          _c("div", [
            _vm._v(
              "\n          " +
                _vm._s(_vm.t("app-checkbox-required-tip")) +
                "\n          "
            ),
            _c("span", { staticClass: "ui-field-required-marker" }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ui-form-row" },
          [
            _c("app-checkbox", {
              attrs: {
                value: _vm.program.attributes.delivery.community,
                label: _vm.t("app-program-delivery-community-based"),
                required: _vm.required,
              },
              on: {
                input: function ($event) {
                  _vm.program.attributes.delivery.community = $event
                  _vm.onInput()
                },
              },
            }),
            _vm._v(" "),
            _vm.program.attributes.delivery.community
              ? _c(
                  "div",
                  { staticClass: "checked-content" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "description description-row description-small description-icon description-icon-align-center description-dynamic-hint alert",
                        attrs: { "data-hint-active": _vm.showPlacePickerHint },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("explore"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.t(
                                "app-program-e-mentoring-locations-description"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("multi-place-picker", {
                      attrs: {
                        label: _vm.t("app-program-delivery-community-based"),
                        required: "true",
                      },
                      on: {
                        remove: function ($event) {
                          return _vm.program.attributes.delivery.communityLocations.splice(
                            $event,
                            1
                          )
                        },
                        placePickerStarted: function ($event) {
                          _vm.showPlacePickerHint = true
                        },
                        placePickerEnded: function ($event) {
                          _vm.showPlacePickerHint = false
                        },
                      },
                      model: {
                        value:
                          _vm.program.attributes.delivery.communityLocations,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.program.attributes.delivery,
                            "communityLocations",
                            $$v
                          )
                        },
                        expression:
                          "program.attributes.delivery.communityLocations",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "description description-small description-dynamic-hint alert help",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.t("app-program-delivery-address-helper-text")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("app-checkbox", {
              attrs: {
                value: _vm.program.attributes.delivery.siteBased,
                label: _vm.t("app-program-delivery-site-based"),
                required: _vm.required,
              },
              on: {
                input: function ($event) {
                  _vm.program.attributes.delivery.siteBased = $event
                  _vm.onInput()
                },
              },
            }),
            _vm._v(" "),
            _vm.program.attributes.delivery.siteBased
              ? _c(
                  "div",
                  { staticClass: "checked-content" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "description description-row description-small description-icon description-icon-align-center description-dynamic-hint alert",
                        attrs: { "data-hint-active": _vm.showPlacePickerHint },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("explore"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.t(
                                "app-program-physical-locations-description"
                              )
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("multi-place-picker", {
                      attrs: {
                        label: _vm.t("app-program-delivery-site-based"),
                        required: "true",
                      },
                      on: {
                        remove: function ($event) {
                          return _vm.program.attributes.delivery.siteBasedLocations.splice(
                            $event,
                            1
                          )
                        },
                        placePickerStarted: function ($event) {
                          _vm.showPlacePickerHint = true
                        },
                        placePickerEnded: function ($event) {
                          _vm.showPlacePickerHint = false
                        },
                      },
                      model: {
                        value:
                          _vm.program.attributes.delivery.siteBasedLocations,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.program.attributes.delivery,
                            "siteBasedLocations",
                            $$v
                          )
                        },
                        expression:
                          "program.attributes.delivery.siteBasedLocations",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "description description-small description-dynamic-hint alert help",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.t("app-program-delivery-address-helper-text")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("app-checkbox", {
              attrs: {
                value: _vm.program.attributes.delivery.eMentoring,
                label: _vm.t("app-program-delivery-e-mentoring"),
                required: _vm.required,
              },
              on: {
                input: function ($event) {
                  _vm.program.attributes.delivery.eMentoring = $event
                  _vm.onInput()
                },
              },
            }),
            _vm._v(" "),
            _vm.program.attributes.delivery.eMentoring
              ? _c(
                  "div",
                  { staticClass: "checked-content" },
                  [
                    _c("e-mentoring-service-area", {
                      attrs: { program: _vm.program },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }